import React, { useEffect, useState, useMemo, useRef } from 'react';
import { MultiselectField } from 'src/components/base/fields/MultiselectField';
import { areStringsInsensitivelyEqual } from 'shared/utils/utils';


export const Value = {
  True: 'true',
  False: 'false',
};

const Options = Object.values(Value).map(x => ({
  id: x, key: x, value: x, text: x.toUpperCase()
}));


export const TextConverters = {
  parse: (text) => ({ value: [typeof(text) === 'string' 
    ? areStringsInsensitivelyEqual(text, Value.True) ? Value.True : Value.False
    : !text ? Value.False : Value.True]
  }),
  format: (values) => ({ value: values[0].value }),
  getDefault: () => [Value.True]
};


export function CheckboxField({ rawField, converters = {}, ...restProps }) {
  return (
    <MultiselectField
      {...restProps} options={Options} isMultiselect={false} 
      converters={{ ...TextConverters, ...converters }}
    />
  );
}

export function getDefaultOption(rawField) {
  return Options[0];
}


export default CheckboxField;
